import React from 'react';
import first from 'lodash/first';
import loadable from '@loadable/component';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { handleGetPage as handleGetPageAction } from '../../../../SearchApp/actions/pagination';
import { constructPaginatedUrl } from '../../../../SearchApp/utils/url';
import { hasEventResults } from '../../../../SearchApp/utils/events';
import { getSearchContent } from '../../../../SearchApp/utils';

import { SearchFooter } from './components';

const SearchFooterLegacy = loadable(() => import('./components'), {
    resolveComponent: (components) => components.SearchFooterLegacy,
});

const SearchFooterWrapper = (props) => {
    const { isBotRequest } = props;
    let Footer = <SearchFooter {...props} />;

    if (isBotRequest) {
        Footer = <SearchFooterLegacy {...props} />;
    }

    return Footer;
};

const _getMaxPage = ({ event }) => {
    const firstKey = first(Object.keys(event));

    let pageCount;

    if (event[firstKey]) {
        pageCount = event[firstKey].pageCount;
    }

    return pageCount;
};

const _getTotalResults = ({ event }) => {
    const firstKey = first(Object.keys(event));

    let totalNumResults = 0;

    if (event[firstKey]) {
        totalNumResults = event[firstKey].objectCount;
    }

    return totalNumResults;
};

const _isNextDisabled = (pagination) => {
    const pageCount = _getMaxPage(pagination);
    const { currentPage } = pagination;

    return currentPage === pageCount - 1;
};

const _mapStateToProps = (state, ownProps) => ({
    isBotRequest: state.app.isBotRequest,
    currentPage: state.pagination.currentPage,
    pageCount: _getMaxPage(state.pagination),
    isNextDisabled: _isNextDisabled(state.pagination),
    prevPageUrl: constructPaginatedUrl(
        state.pagination.currentPage - 1,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    nextPageUrl: constructPaginatedUrl(
        state.pagination.currentPage + 1,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    firstPageUrl: constructPaginatedUrl(
        0,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    lastPageUrl: constructPaginatedUrl(
        _getMaxPage(state.pagination) - 1,
        state.search.eventSearch,
        state.location.slug,
        ownProps.history.location,
    ),
    hasEventResults: hasEventResults(
        getSearchContent(
            state.content.entities,
            state.pagination,
            state.currencyFormat,
        ),
    ),
    totalNumResults: _getTotalResults(state.pagination),
});

const _mapDispatchToProps = {
    handleGetPage: handleGetPageAction,
};

export const SearchFooterContainer = withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(SearchFooterWrapper),
);
